import React from 'react'

export default function SystemPage() {
    return (
        <div>
            System Page
        </div>
    )
}
